export default __webpack_public_path__ + "assets/images/fc9c3ea331b830170a14f72d0856e441.svg";